// extracted by mini-css-extract-plugin
module.exports = {"List":"styles_List__mR6Nb","button":"styles_button__KtQRj"};